import {
  requestClassList,
  requestSubjectDetail,
  requestPartQuestion,
  requestQuestionNote,
  requestQuestionSave,
  requestQuestionResponse,
  requestQuestionWrong,
  requestClassStatistic
} from "../_api";

const getClassList = async (context, data) => {
  await requestClassList(data)
    .then(response => {
      context.commit("SET_CLASS_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getSubjectDetail = async (context, id) => {
  await requestSubjectDetail(id)
    .then(response => {
      context.commit("SET_SUBJECT_DETAIL", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getPartQuestion = async (context, { partId, questionId, action }) => {
  context.commit("SET_QUESTION_ACTION", action);

  await requestPartQuestion({ partId, questionId, action })
    .then(response => {
      context.commit("SET_QUESTION_DETAIL", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getQuestionSave = async (context) => {
  await requestQuestionSave()
    .then(response => {
      context.commit("SET_QUESTION_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getQuestionWrong = async (context) => {
  await requestQuestionWrong()
    .then(response => {
      context.commit("SET_QUESTION_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const postQuestionNote = async (context, data) => {
  await requestQuestionNote(data)
    .then(response => {
      //
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const postQuestionResponse = async (context, data) => {
  await requestQuestionResponse(data)
    .then(response => {
      context.commit("SET_QUESTION_CORRECT", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getClassStatistic = async (context) => {
  await requestClassStatistic()
    .then(response => {
      context.commit("SET_CLASS_STATISTIC", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const clearQuestion = (context) => {
  context.commit("CLEAR_QUESTION");
}

const clearQuestionList = (context) => {
  context.commit("CLEAR_QUESTION_LIST");
}

const setQuestionIndex = (context, data) => {
  context.commit("SET_QUESTION_INDEX", data);
}

export default {
  getClassList,
  getClassStatistic,
  getSubjectDetail,
  getPartQuestion,
  getQuestionSave,
  getQuestionWrong,
  postQuestionNote,
  postQuestionResponse,
  clearQuestion,
  clearQuestionList,
  setQuestionIndex
};
